<div id="{{position}}" class="position-relative">
  <div *ngIf="!loading">
    <header [attr.data-aos]="allElementAnimation ? allElementAnimation : null" class="app-header-background"
      [ngStyle]="{ 'background-color': backgroundColor,'background-image': backgroundColor.includes('#')?'none':backgroundColor }"
      [ngClass]="activatePadding?'header-padding-top':''">
      <div [attr.data-aos]="textAnimation ? textAnimation : null"
        class="app-header-headline pt-40 mb-40 global-max-width">
        <h1 class="center" [ngClass]="[titleSize]"
          [ngStyle]="{ 'font-family': titleFontFamily ? titleFontFamilyName : '' ,'color': titleColor?titleColor:textColor,'font-weight': fontWeight }">
          {{title}}</h1>
        <p *ngIf="subTitle" [ngStyle]="{ 'color': textColor }" class="sub-title center">{{subTitle}}</p>
      </div>
      <div class="pb-60 global-max-width">
        <div [attr.data-aos]="itemsAnimation ? itemsAnimation : null" fxLayout="column" fxLayout.gt-sm="row wrap"
          fxLayoutAlign="center center">
          <ng-container *ngFor="let item of teamData; let memberIndex = index">
            
            <a *ngIf="item.memberLink" href="{{item.memberLink}}" target="_blank">
              <div [ngClass]="classMember + ' member'">
                <div fxFlex="1 1 100px" fxFlexAlign="center">
                  <div class="avatar-container">
                    <img [alt]="item.name"
                      [src]="item.picture ? item.picture : 'https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/blank-profile-picture.png'"
                      class="avatar-pic" (error)="updateUrl($event)">
                  </div>
                </div>
                <div fxFlex>
                  <div class="colorWhite pt-20" [ngStyle]="{ 'color': item.textColor }">
                    <cite class="mt-0 mb-20" [ngStyle]="{ 'color': item.textColor }">{{ item.name }} </cite>
                    <p [ngStyle]="{ 'color': item.textColor }"> {{ item.description }}
                    </p>
                  </div>
                </div>
              </div>
            </a>
            <div *ngIf="!item.memberLink" [ngClass]="classMember + ' member'">
              <div fxFlex="1 1 100px" fxFlexAlign="center">
                <div class="avatar-container">
                  <img [alt]="item.name"
                    [src]="item.picture ? item.picture : 'https://s3.amazonaws.com/ai-images.sitecreator.io/assets/img/blank-profile-picture.png'"
                    class="avatar-pic" (error)="updateUrl($event)">
                </div>
              </div>
              <div fxFlex>
                <div class="colorWhite pt-20" [ngStyle]="{ 'color': item.textColor }">
                  <cite class="mt-0 mb-20" [ngStyle]="{ 'color': item.textColor }">{{ item.name }} </cite>
                  <p [ngStyle]="{ 'color': item.textColor }"> {{ item.description }}
                  </p>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </header>
  </div>
  <app-shape-matrial [shape]="shape" [backgroundColor]="backgroundColor?backgroundColor:'var(--light-bg)'"></app-shape-matrial>
</div>